import React, { useEffect } from 'react';
import { ComposableDeviceFormProps } from '../../../../components/ComposableDevice/ComposableDeviceForm/ComposableDeviceForm';
import { getPolyglot } from '../../../../i18n';
import { Box, Button, Stack, Typography } from '@mui/material';
import { DeviceForm } from './ComposableDeviceForm/DeviceForm';
import { DecksForm } from './ComposableDeviceForm/DecksForm';
import * as yup from 'yup';
import ButtonLoading from '../../../../components/commons/ButtonLoading/ButtonLoading';

export const ComposableDeviceForm = (
  props: ComposableDeviceFormProps & { closeAddComposableDevice: () => void }
) => {
  const {
    setValidationSchema,
    validationSchema,
    formik,
    closeAddComposableDevice,
  } = props;
  const polyglot = getPolyglot();
  const isEditMode = Boolean(formik.values?.id);

  useEffect(() => {
    if (setValidationSchema) {
      const devicesValidationSchema = yup.object({
        devices: yup
          .array()
          .of(yup.string())
          .min(1, polyglot.t('composable_device.devices_required'))
          .required(polyglot.t('composable_device.devices_required'))
          .test(
            'devices-equality',
            polyglot.t('fours_fringand.oven.devices_must_be_unique'),
            function (items) {
              const filteredItems = items.filter(
                (item) => item && item?.trim()?.length > 0
              );
              return new Set(filteredItems).size === filteredItems.length;
            }
          )
          .test('model-deck-quantity', function (items, context) {
            const commandersQuantity = Number(
              context.parent.composableDevice?.labels?.commandersQuantity
            );
            if (
              !isNaN(commandersQuantity) &&
              items.filter((item) => item && item?.trim()?.length > 0)
                ?.length !== Number(commandersQuantity)
            )
              return this.createError({
                message: polyglot.t(
                  'fours_fringand.oven.devices_quantity_must_equal'
                ),
              });

            return true;
          }),
      });

      setValidationSchema(validationSchema.concat(devicesValidationSchema));
    }
  }, []);
  return (
    <>
      {!isEditMode ? (
        <Typography variant="body2" textAlign={'start'}>
          {polyglot.t('composable_device.add_composable_device_information')}
        </Typography>
      ) : null}
      <form onSubmit={formik.handleSubmit}>
        <Stack
          display="grid"
          gridTemplateColumns={isEditMode ? '1fr' : '1fr 2fr'}
          gap={1}
          marginTop={2}
        >
          <DeviceForm {...props} />
          <DecksForm formik={formik} />
        </Stack>
        <Stack>
          {!isEditMode ? (
            <Box
              pt={2}
              display="flex"
              justifyContent="flex-end"
              gap={2}
              width={'100%'}
            >
              <Button
                type="button"
                onClick={closeAddComposableDevice}
                variant="text"
              >
                {polyglot.t('device.cancel_button_title')}
              </Button>
              <ButtonLoading
                type="submit"
                variant="contained"
                onClick={formik.submitForm}
                disabled={formik.isSubmitting || !formik.isValid}
                loading={formik.isSubmitting}
              >
                {polyglot.t('device.add_button_title')}
              </ButtonLoading>
            </Box>
          ) : null}
        </Stack>
      </form>
    </>
  );
};
